/**
 * A panel's title and the one sentence explaining what it is for.
 *
 * Small enough to be worth questioning, and kept because the money screens all carry a line of
 * explanation and three copies of the same markup is how they end up styled three ways.
 */
export function PanelHeading({ title, hint }: { readonly title: string; readonly hint?: string }) {
  return (
    <header className="panel__heading">
      <h2>{title}</h2>
      {hint ? <p className="muted">{hint}</p> : null}
    </header>
  );
}
